import { render, staticRenderFns } from "./PelletsHowItWorks.vue?vue&type=template&id=1f14f9d1&scoped=true"
import script from "./PelletsHowItWorks.vue?vue&type=script&lang=ts"
export * from "./PelletsHowItWorks.vue?vue&type=script&lang=ts"
import style0 from "./PelletsHowItWorks.vue?vue&type=style&index=0&id=1f14f9d1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f14f9d1",
  null
  
)

export default component.exports